import { render, staticRenderFns } from "./IconClone.vue?vue&type=template&id=2c54e3f0"
import script from "./IconClone.vue?vue&type=script&lang=js"
export * from "./IconClone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports